export function createConfig(token) {
    return {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {}
    };
}
